export function shortenString(companyName: string, maxLength: number) {
  if (companyName.length > maxLength) {
    return `${companyName.slice(0, maxLength)}...`;
  }

  return companyName;
}
